export default {
  name: 'cco:GetStartedCard',
  title: 'Card with Get Started flow',
  owner: 'System',
  solution: '',
  tags: ['widget', 'card', 'get started'],
  createdAt: 'Feb 20, 2024, 10:14 AM',
  updatedAt: 'Feb 25, 2024, 9:59 PM',
  spec: {
    props: {
      asset: 'img.svg',
      closeHandler: 'Close handler',
    },
    view: [
      {
        instanceOf: 'div',
        className: '${ "flex" }',
        children: [
          [
            'div',
            {
              '.': 'flex flex-col items-start self-stretch bg-default-bg-weak gap-4 p-6 rounded-xl ml-3 mr-4 w-full',
              style: {
                boxShadow: '0px 3px 8px 0px rgba(0, 0, 0, 0.08)',
              },
            },
            [
              [
                'div',
                {
                  '.': 'flex w-full justify-between',
                  style: { font: 'var(--typography-heading-sub-section)', color: 'var(--default-text-strong)' },
                },
                [
                  ['div', {}, 'Get Started'],
                  [
                    'div',
                    {
                      '.': 'hover:cursor-pointer',
                    },
                    [
                      [
                        'uik:Icon.Action.Disable',
                        {
                          size: 'SMALL',
                          onClick: '/${ props.closeHandler }',
                        },
                      ],
                    ],
                  ],
                ],
              ],
              [
                'div',
                { '.': 'flex w-full' },
                [
                  [
                    'div',
                    { '.': 'flex-col items-start mr-5 w-3/4' },
                    [
                      [
                        'div',
                        { '.': 'flex-col' },
                        [
                          [
                            'div',
                            { '.': 'flex' },
                            [
                              [
                                'div',
                                {
                                  '.': 'mt-1',
                                  style: {
                                    font: 'var(--typography-p3-default)',
                                    color: 'var(--default-text-medium)',
                                  },
                                },
                                [
                                  [
                                    'span',
                                    {},
                                    'Answer a few questions to help us get to know more about your technical setup so we can provide a customized onboarding guide. Or, you can ',
                                  ],
                                  [
                                    'span',
                                    {
                                      '.': 'hover:cursor-pointer no-underline',
                                      style: {
                                        font: 'var(--typography-p3-bold)',
                                        color: 'var(--interact-text)',
                                        '&:hover': {
                                          color: 'var(--interact-text)',
                                        },
                                      },
                                      onClick: '/${ function($e){ $emitShellEvent("HELP_CENTER_OPEN")} }',
                                    },
                                    'view the complete setup guide.',
                                  ],
                                ],
                              ],
                            ],
                          ],
                          [
                            'uik:Button',
                            {
                              type: 'PRIMARY',
                              className: {
                                marginTop: '12px',
                              },
                              onClick:
                                '/${ function($e){ $navigateTo( {"href":$buildUrlWithQuery("/ui/cco/dashboardHome")} ) } }',
                            },
                            "Let's Go",
                          ],
                        ],
                      ],
                    ],
                  ],
                  [
                    'div',
                    { '.': 'w-2/5' },
                    [
                      [
                        'img',
                        {
                          src: '/${ props.asset }',
                          height: '240px',
                          width: '453px',
                        },
                      ],
                    ],
                  ],
                ],
              ],
            ],
          ],
        ],
      },
    ],
  },
};
